<template>
  <div class="main-body">
    <div class="header">订单列表</div>
    <div class="out">

      <div class="search2">

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "订单列表.xls"
            style="display: inline-block;margin-right: 10px;">
          <el-button size="mini" type="success">导出</el-button>
        </download-excel>

        <div style="float: right">

          <el-input v-model="userName" placeholder="老人" disabled style="width:150px;margin-right: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="selectElderly"></el-button>
          </el-input>

          <el-input v-model="serveName" placeholder="服务人员" disabled style="width:150px;margin-right: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="selectServe"></el-button>
          </el-input>

          <el-date-picker style="margin-right: 10px;width:210px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="datetimerange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:150px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>
        <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>
        <el-table-column prop="user.phone" label="老人手机号" width="150"></el-table-column>


        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>



        <el-table-column prop="price" label="总价" width="105"></el-table-column>

        <el-table-column width="105" label="订单来源" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderFrom =='business'">商家</div>
            <div v-if="scope.row.orderFrom =='serve'">服务人员</div>
            <div v-if="scope.row.orderFrom =='android' ">长者端</div>
            <div v-if="scope.row.orderFrom =='table' ">收银机</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType ==2 ">单独服务</div>
            <div v-if="scope.row.orderType ==3 ">合并服务</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="付款类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.payType == 'wx' ">微信</div>
            <div v-if="scope.row.payType == 'ali' ">支付宝</div>
            <div v-if="scope.row.payType == 'yue' ">余额</div>
            <div v-if="scope.row.payType == 'cash' ">现金</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
          </template>
        </el-table-column>
        <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>

        <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>
        <el-table-column prop="orderServe.startTime" :formatter="timefilter" width="200" label="服务开始时间"></el-table-column>
        <el-table-column prop="orderServe.endTime" :formatter="timefilter" width="200" label="服务结束时间"></el-table-column>

        <el-table-column width="120" label="开始服务备注">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOStart !=null ">
              {{scope.row.orderServeRecordDTOStart.remark}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="开始服务图片">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOStart !=null ">
              <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.orderServeRecordDTOStart.listOrderServeRecordImg" :key="index">
                <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" label="结束服务备注">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOEnd !=null ">
              {{scope.row.orderServeRecordDTOEnd.remark}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="结束服务图片">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOEnd !=null ">
              <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.orderServeRecordDTOEnd.listOrderServeRecordImg" :key="index">
                <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
              </el-popover>
            </div>
          </template>
        </el-table-column>


        <el-table-column prop="order.receiveName" width="100" label="收货人"></el-table-column>
        <el-table-column prop="order.receivePhone" width="120" label="收货人手机"></el-table-column>
        <el-table-column prop="order.receiveAreaPath" width="200" label="收货人地区"></el-table-column>
        <el-table-column prop="order.receiveAddress" width="200" label="收货人地址"></el-table-column>


        <el-table-column fixed="right" label="操作" width="100" >
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.isDelete!=1" @click="deleteOrder(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <SelectElderly ref="mySelectElderly" v-show="showModalSelectElderly"
                   v-on:closeSelectElderly="showModalSelectElderly=false"
                   v-on:setElderly="setElderly"></SelectElderly>

    <SelectServe ref="mySelectServe" v-show="showModalSelectServe"
                 v-on:closeSelectServe="showModalSelectServe=false"
                 v-on:setServe="setServe"></SelectServe>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree";
import SelectElderly from "./SelectElderly";
import SelectServe from "./SelectServe";

export default {
  name: "Page",
  data() {
    return {

      showModalSelectElderly: false,
      showModalSelectServe: false,


      serveOrderPrice:0,

      status_arr: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 10, label: '待付款'
        }, {
          value: 11, label: '待接单'
        }, {
          value: 12, label: '已接单'
        }, {
          value: 13, label: '服务中'
        }, {
          value: 14, label: '服务完成'
        }, {
          value: 15, label: '交易取消'
        }, {
          value: 16, label: '已评价'
        }
      ],
      status: -1,

      isDelete:0,
      delete_arr: [
        {value: 0, label: '全部订单'},
        {value: 1, label: '正常订单'},
        {value: 2, label: '已删除订单'},
      ],

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      userCode: '',
      userName:'',
      serveCode:'',
      serveName:'',


      startEndTime:[],


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,

      showSum:true,

      showModal:false,
      json_fields: {
        "流水号": {
          field:"serialNumber",
          callback:value=>{
            return value+"-";
          }
        },
        "老人姓名": "user.name",
        "老人手机号": "user.phone",
        "服务项目": {
          filed:"listOrderGoodsDTO",
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsName+'</div>';
            }
            return str;
          }
        },
        "单价": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsPrice+'</div>';
            }
            return str;
          }
        },
        "数量": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].number+'</div>';
            }
            return str;
          }
        },
        "总价": "price",
        "订单来源": {
          field:"orderFrom",
          callback:value=>{
            let title = "";
            if(value == 'pc'){
              title = "商家预工单";
            }
            if(value == 'android'){
              title = "长者端";
            }
            if(value == 'table'){
              title = "收银机";
            }
            return title;
          }
        },
        "订单类型": {
          field:"orderType",
          callback:value=>{
            let title = "";
            if(value == 2){
              title = "单独服务";
            }
            if(value == 3){
              title = "合并服务";
            }
            return title;
          }
        },
        "付款类型": {
          field:"payType",
          callback:value=>{
            let title = "";
            if(value == 'cash'){
              title = "现金";
            }
            if(value == 'yue'){
              title = "余额";
            }
            if(value == 'wx'){
              title = "微信";
            }
            if(value == 'ali'){
              title = "支付宝";
            }
            return title;
          }
        },
        "订单状态": {
          field:"status",
          callback:value=>{
            let title = "";
            if(value == '10'){
              title = "待付款";
            }
            if(value == '11'){
              title = "待接单";
            }
            if(value == '12'){
              title = "待开始";
            }
            if(value == '13'){
              title = "待结束";
            }
            if(value == '14'){
              title = "待评价";
            }
            if(value == '15'){
              title = "已取消";
            }
            if(value == '16'){
              title = "已评价";
            }
            return title;
          }
        },
        "删除": {
          field:"isDelete",
          callback:value=>{
            let title = "";
            if(value == 0){
              title = "";
            }
            if(value == 1){
              title = "已删除";
            }
            return title;
          }
        },
        "创建时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "收货人": {
          field:"order.receiveName",
        },
        "收货人手机": {
          field:"order.receivePhone",
        },
        "收货人地区": {
          field:"order.receiveAreaPath",
        },
        "收货人地址": {
          field:"order.receiveAddress",
        },
        "服务人员": "serveName",
        "开始时间": {
          field:"orderServe.startTime",
          callback:value=>{
            if(value == ''){
              return "";
            }
            return timefilters(value);
          }
        },
        "结束时间": {
          field:"orderServe.endTime",
          callback:value=>{
            if(value == ''){
              return "";
            }
            return timefilters(value);
          }
        },
        "服务开始备注": {
          callback:value=>{
            let start = value.orderServeRecordDTOStart;
            if(start == null){
              return '';
            }
            return start.remark;
          }
        },
        "服务开始照片": {
          callback:value=>{
            let start = value.orderServeRecordDTOStart;
            if(start == null){
              return '';
            }
            let str = "";
            let arr = start.listOrderServeRecordImg;
            for(var i=0;i<arr.length;i++){
              let url = this.imgUrl+arr[i].imgPath+'_watermark.jpg';
              str += '<div>'+url+'</div>';
            }
            return str;
          }
        },
        "服务结束备注": {
          callback:value=>{
            let start = value.orderServeRecordDTOEnd;
            if(start == null){
              return '';
            }
            return start.remark;
          }
        },
        "服务结束照片": {
          callback:value=>{
            let start = value.orderServeRecordDTOEnd;
            if(start == null){
              return '';
            }
            let str = "";
            let arr = start.listOrderServeRecordImg;
            for(var i=0;i<arr.length;i++){
              let url = this.imgUrl+arr[i].imgPath+'_watermark.jpg';
              str += '<div>'+url+'</div>';
            }
            return str;
          }
        },

      },


      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },


    }
  },
  components: {
    elSelectTree, SelectElderly,SelectServe,
  },
  created() {
    this.init();
    this.getZoneList();
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      this.startEndTime = [start, end];

      this.getList();
    },


    getZoneValue(val) {
      this.zoneCode = val
    },
    getZoneList:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


    selectElderly(){
      this.showModalSelectElderly = !this.showModalSelectElderly;
      this.$refs.mySelectElderly.init();
    },
    setElderly(row) {
      this.userCode = row.userCode;
      this.userName = row.name;
    },


    selectServe(){
      this.showModalSelectServe = !this.showModalSelectServe;
      this.$refs.mySelectServe.init();
    },
    setServe(row) {
      this.serveCode = row.userCode;
      this.serveName = row.name;
    },



    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },


    getSummaries(param) {

      //const { columns, data } = param;console.log(data);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = '合计';
        }

        if (index == 6) {
          sums[index] = parseFloat(this.serveOrderPrice).toFixed(2);
        }


        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        //     sums[index] += ' 元';
        // } else {
        //     sums[index] = 'N/A';
        // }



      });

      return sums;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true

      //if(this.isDelete == ''){this.isDelete = 0;}

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],

        zoneCode:this.zoneCode,
        userCode:this.userCode,
        serveCode:this.serveCode,
        //isDelete:this.isDelete-1,
        status:this.status,

      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusiness/PageForElderlyOrder",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          //this.serveOrderPrice=response.data.data.allPrice;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },





    async fetchData(){

      //if(this.isDelete == ''){this.isDelete = 0;}

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,

        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],

        zoneCode:this.zoneCode,
        status:this.status,
        userCode:this.userCode,
        serveCode:this.serveCode,

      }

      const response = await this.$axios.post(this.$shopUrl + "OrderBusiness/PageForElderlyOrder",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },


    deleteOrder(row){
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusiness/DeleteOrderBusiness",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });
    },



  }
}
</script>


<style lang="scss" scoped>

.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;
}


</style>
